import { useTranslation } from 'react-i18next';
import Icon from '../../common/Icon';

export default function WireTransfer() {
  const { t } = useTranslation(['DonatePage']);

  return (
    <div className={`donate-modal__container`}>
      <div className="donate-modal__wire-transfer">
        <Icon name="wire-transfer" className="wire-transfer-icon" />
        <h2>{t('donateViaWireTransfer')}</h2>
        <p>
          {t('donateViaWireTransferDescription')}
          <a href="mailto:donations@manaraschool.org"> donations@manaraschool.org</a>
          {t('donateViaWireTransferDescription2')}
        </p>
      </div>
    </div>
  );
}
